
import { getSocialLinks } from '~profile_stats/stores/profileStats';

const ACTION_PREFIX = 'MENTEE/PROFILE_SHARE';

export const PROFILE_MODAL_STATE = `${ACTION_PREFIX}/PROFILE_MODAL_STATE`;
export const SET_TITLE_FOR_NUDGE = `${ACTION_PREFIX}/SET_TITLE_FOR_NUDGE`;


export function updateProfileModalState(payload) {
  return async (dispatch) => {
    dispatch(getSocialLinks());
    dispatch({
      type: PROFILE_MODAL_STATE, payload,
    });
  };
}

export function setTitleForNudge(payload) {
  return async (dispatch) => {
    dispatch(getSocialLinks());
    dispatch({
      type: SET_TITLE_FOR_NUDGE, payload,
    });
  };
}

const initialState = {
  profileModalState: false,
  title: '',
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case PROFILE_MODAL_STATE:
      return {
        ...state,
        profileModalState: payload,
      };
    case SET_TITLE_FOR_NUDGE:
      return {
        ...state,
        title: payload,
      };
    default:
      return state;
  }
}
